import React from 'react'
import { Button } from "react-bootstrap"
import { LINEAR_GRADIENT_BG } from '../../const'


export default function CustomButtonApp({ title, type, onClick, startIcon, endIcon, variant, background, color }) {
    return (
        <Button type={type ? type : "button"} onClick={onClick} variant={variant}>
            {startIcon} {title} {endIcon}
        </Button>
    )
}
